const func = $target => {
    $(".course-list-open-inner ul li,.course-list-open-inner ol li").each(function () {
        var lines = $(this).html().split("<br>");
        $(this).html('<label>' + lines.join("</label><label>") + '</label>');
    });

    $('.course-list-open-inner ul li,.course-list-open-inner ol li').each(function() {
        var $this = $(this);
        var img = $this.parent().parent().find('.icon picture').clone();
        console.log(img)
        var src = img.find('img').data('src');
        img.find('img').attr('src',src);
        console.log(src)
        $this.prepend(img)
    });
}
export default func;
